export default __webpack_public_path__ + "static/media/learn-more-card-9.b4a645af.svg";